import {SerializedStyles} from '@emotion/react';
import {css, useTheme} from '@mui/material';
import * as React from 'react';
import {GetStylesFunction} from 'src/js/common/types';

import {DlMuiComponentBox} from './DlMuiComponentBox';
import {IconHeaderWithSearch} from './IconHeaderWithSearch';

interface OwnProps {
  isOverflow?: boolean;
  noTopPadding?: boolean;
  style?: React.CSSProperties;
  inputCss?: SerializedStyles;
  iconName?: string;
  label?: string;
  componentBoxInputCss?: SerializedStyles;
  iconCss?: SerializedStyles;
  headerButtons?: React.ReactNode;
  headerBox?: React.ReactNode;
  defaultScroll?: number;
  onScroll?: (event: React.UIEvent<HTMLElement>) => void;
}

type Props = OwnProps;

export const DlMuiComponentWrapper: React.FC<Props> = (props) => {
  const {
    children,
    isOverflow = true,
    noTopPadding = false,
    style,
    inputCss,
    iconName,
    label,
    componentBoxInputCss,
    iconCss,
    headerButtons,
    headerBox,
    defaultScroll,
    onScroll,
  } = props;

  const theme = useTheme();
  const styles = getStyles({
    theme,
    params: {isOverflow, inputCss, noTopPadding},
  });

  return (
    <div css={styles.wrapper} style={style}>
      <IconHeaderWithSearch iconCss={iconCss} iconName={iconName} label={label}>
        {headerButtons}
      </IconHeaderWithSearch>
      {headerBox}
      <DlMuiComponentBox
        inputCss={componentBoxInputCss}
        noTopPadding={noTopPadding}
        isOverflow={isOverflow}
        defaultScroll={defaultScroll}
        onScroll={onScroll}
      >
        {children}
      </DlMuiComponentBox>
    </div>
  );
};

DlMuiComponentWrapper.displayName = 'DlMuiComponentWrapper';

const getStyles: GetStylesFunction = (options) => ({
  wrapper: css(
    {
      backgroundColor: '#ffffff',
      gap: `${options?.theme?.spacing(3)}`,
      display: 'flex',
      flexDirection: 'column',
      padding: `${options?.theme?.spacing(4)}`,
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      borderRadius: `${options?.theme?.spacing(6)}`,
      height: '100%',
      overflow: 'hidden',
    },
    options?.params?.inputCss
  ),
});
